import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import utils, { makeUUID, dateTime, } from './utils';
Vue.prototype.$utils = utils;
Vue.prototype.$makeUUID = makeUUID;
Vue.prototype.$dateTime = dateTime;
import api, { get, post, } from './request';
Vue.prototype.$api = api;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
import axios from 'axios';
Vue.prototype.$axios = axios;
Vue.filter('dateFormat', utils.dateTime);
Vue.filter('dateTime', utils.dateTime);
import { Toast, Dialog, Empty } from "vant";
Vue.use(Empty);
Toast.setDefaultOptions('loading', { duration: 0, forbidClick: true, loadingType: "spinner" });
Vue.use(Toast);
Vue.use(Dialog);
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
